import styled from "styled-components";

import { inputGlowNotOnChildren } from "../../utils/styles";

/**
 * A mostly unstyled, div-like container to use instead of a naked onClick()
 */
const ContainerButton = styled.button`
  box-sizing: border-box;

  outline: transparent;
  background-color: transparent;
  border: none;
  font-family: inherit;
  font-size: inherit;

  cursor: pointer;

  border: 1px solid transparent;
  ${inputGlowNotOnChildren}
`;

export default ContainerButton;
